module.exports = new __parcel__URL__("welcome-to-project-pages-spork-rebranding-dark.1a4ad80a.png").toString();